import { render, staticRenderFns } from "./ProductAttributeSelector.vue?vue&type=template&id=540b18c2&scoped=true&"
import script from "./ProductAttributeSelector.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributeSelector.vue?vue&type=style&index=0&id=540b18c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b18c2",
  null
  
)

export default component.exports